import React, {useEffect} from 'react';
import styles from './Alert.module.sass'


function Alert(props) {

  let alertRef = React.createRef();

  useEffect(() => {
    if (props.error) {
      alertRef.scrollIntoView({behavior: "smooth", block: "start"});
    }
  }, []);

    return(
      <div ref={el => {alertRef = el}} className={[styles.alert, props.error ? styles.error : ''].join(' ')}>
        <i className={["icon", props.error ? "icon-erro-m" : "icon-atencao-p"].join(' ')}/>
        <div className={styles.alertContent}>
          <h3 className={styles.title}>{props.title}</h3>
          <p className={styles.text}>
            {props.text}
          </p>
        </div>
      </div>
    )
}

export default Alert;
